import {defaultAuthor, defaultTime} from "../../constants/copyright";

export const createNewsDate = (list)=>{
  return list.map(({created_at, preview, title, header_image, headings, href,content,author,preview_mobile}) => {
    return {
      tags: headings,
      title: title,
      date: created_at,
      color:headings && headings[0]?.color || "#B58F25" ,
      href,
      time: content?.time || defaultTime,
      author: {
        avatar: author?.photo || defaultAuthor.avatar,
        name: author?.first_name || author?.last_name ? `${author?.first_name} ${author?.last_name} `: defaultAuthor.name
      },
      picture:{
        imgAttr:{
          src:preview || header_image,
          alt:"Превью",
        },
        sourceData:{
          sources:[
            {
              srcSet:preview_mobile || preview || header_image,
              media:'(max-width: 600px)',
              alt:"Превью",
            }
          ]
        }
      },
      image: preview === '' ? header_image : preview
    }
  })
}
